import { Modal, Table } from '@drip/drip-design';
import React, { useState, useEffect } from 'react';
import apis from '@/apis/goodsPool';
import moment from 'moment';
import RenderHP_rule, {
  PopoverRule,
} from '@/pages/activity-manage/merchants/detail/components/category-hp/components/category-inventory-table/components/render-HP-rule';

const STATUS = ['', '接收', '驳回', '移除'];

function AcceptHistoryModal({ activityId, log_sense_id }) {
  const [visible, setVisible] = useState(false);
  const [allRuleDetail, setAllRuleDetail] = useState({}); //表格货盘规则明细缓存
  const [list, setList] = useState({
    currentPage: 1,
    pageSize: 10,
    totalCount: 0,
    list: [],
  });
  const [page, setPage] = useState({
    currentPage: 1,
    pageSize: 10,
  });

  //表格货盘规则明细缓存操作
  const getAllRuleDetail = async (historyId) => {
    if (allRuleDetail[historyId]) return;
    try {
      const res = await apis.queryInventoryRule({ historyId: historyId, activityId });
      const { ret, msg, data } = res;
      if (ret !== '0' || !data) throw msg;
      const rule = {};
      rule[historyId] = data.list;
      setAllRuleDetail((val) => Object.assign({}, val, rule));
    } catch (ex) {
      message.error(ex || '规则明细请求失败！');
    }
  };

  const columns = [
    {
      title: '货盘信息',
      width: 180,
      render: (record) => {
        return (
          <div className="PH_info">
            <div>{record.inventoryName}</div>
            {record.operatedTime ? (
              <div style={{ color: 'rgba(0, 0, 0, 0.45)' }}>
                {STATUS[record.status]}于 {moment(record.operatedTime).format('YYYY-MM-DD HH:mm')}
              </div>
            ) : null}
          </div>
        );
      },
    },
    {
      title: '创建人',
      dataIndex: 'creatorErp',
      width: 100,
    },
    {
      title: '子策略',
      render: (record) => {
        return record.subStrategyNames?.join('、') || '';
      },
      width: 120,
    },
    {
      title: '货盘规则',
      render(record) {
        return (
          <RenderHP_rule
            rules={record.rules}
            extra={
              <PopoverRule rules={allRuleDetail[record.historyId]}>
                <a onMouseOver={() => getAllRuleDetail(record.historyId)}>查看明细</a>
              </PopoverRule>
            }
          />
        );
      },
    },
    {
      title: '操作状态',
      width: 120,
      render(record) {
        return <span className={`accept_status_${record.status}`}>已{STATUS[record.status]}</span>;
      },
    },
  ];

  useEffect(() => {
    if (!visible || !activityId) return;
    let didMount = true;
    apis
      .acceptedHistory({ activityId, ...page })
      .then((res) => {
        if (!didMount) return;
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg;
        setList(data);
      })
      .catch((ex) => {
        message.error(ex || '类目货盘列表请求失败！');
      });
    return () => {
      didMount = false;
    };
  }, [visible, activityId, page]);
  return (
    <>
      <a
        onClick={() => {
          window.log('yx_center', 'accept_history', activityId, log_sense_id);
          setVisible(true);
        }}
      >
        接收历史
      </a>
      <Modal
        visible={visible}
        title="接收历史"
        onCancel={() => setVisible(false)}
        width={1155}
        onOk={() => setVisible(false)}
      >
        <Table
          className="category-inventory-accept-history"
          columns={columns}
          dataSource={list.list}
          rowKey="historyId"
          pagination={{
            hideOnSinglePage: true,
            current: page.currentPage,
            total: list.totalCount,
            pageSize: page.pageSize,
            onChange: (page) => {
              setPage({ ...page, currentPage: page });
            },
          }}
        />
      </Modal>
    </>
  );
}

export default AcceptHistoryModal;
